"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _axios = _interopRequireDefault(require("axios"));

var _loaders = _interopRequireDefault(require("../helpers/loaders"));

var _utils = require("../helpers/utils");

var _modal = _interopRequireDefault(require("../components/modal"));

var _productForm = _interopRequireDefault(require("../components/product-form"));

var _productSubscription = _interopRequireDefault(require("../components/product-subscription"));

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _productSwatches = _interopRequireDefault(require("../components/product-swatches"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Component: Quick view
 * ------------------------------------------------------------------------------
 * An quick view file that contains scripts to function.
 *
 * @namespace quickView
 */

/**
 * DOM selectors.
 */


var selectors = {
  addToCart: '[js-quick-view="addToCart"]',
  container: '[js-quick-view="container"]',
  viewport: '[js-quick-view="viewport"]',
  toggleSelectors: '[js-quick-view="toggle"]',
  body: '[js-quick-view="body"]'
};
/**
 * Attribute and data selectors.
 */

var dataSelectors = {
  quickView: 'js-quick-view'
};
/**
 * Create a new quick view object.
 * @param {object} config - Settings object defined when instantiating.
 */

var _default = function _default() {
  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    viewport: document.querySelector(selectors.viewport),
    toggleSelectors: document.querySelector(selectors.toggleSelectors),
    body: document.querySelector(selectors.body)
  };
  /**
   * Instance config settings.
   */

  var config = {
    disableScroll: true
  };
  /**
   * Global instances.
   */

  var modal = new _modal["default"]('quick-view', config);
  /**
   * Initialise component.
   */

  function init() {
    setTriggerEvents();
    modal.init();
  }
  /**
   * Set trigger listeners.
   */


  function setTriggerEvents() {
    (0, _utils.on)('click', nodeSelectors.container, function (event) {
      return handleQuickViewClick(event);
    });
  }
  /**
   * Handle quick view toggle click event.
   * @param {Event} event - Click event.
   */


  function handleQuickViewClick(event) {
    if (!isTargetToggle(event.target)) {
      return;
    }

    event.preventDefault();
    setLoadingState();
    toggleQuickView(event.target);
  }
  /**
   * Detect quick view toggle click.
   * @param {HTMLElement} target - Clicked target to check quick view attributes against.
   */


  function isTargetToggle(target) {
    return typeof target.attributes[dataSelectors.quickView] !== 'undefined' && target.attributes[dataSelectors.quickView].nodeValue === 'toggle';
  }
  /**
   * Checks if product is a subscription parent and loads corresponing script.
   */


  function loadFormScript() {
    var productType = nodeSelectors.body.querySelector('form').dataset.type.toLowerCase();

    if (productType === 'subscription') {
      (0, _productSubscription["default"])().init();
    } else {
      initProductForm();
    }
  }
  /**
   * Toggle quick view modal after fetching data from toggle target.
   * @param {HTMLElement} element- Quick view button element.
   */


  function toggleQuickView(element) {
    modal.show();

    _axios["default"].get(getProductUrl(element)).then(function (response) {
      nodeSelectors.body.innerHTML = response.data;
      removeLoadingState();
      loadFormScript();
      setAddToCartEvents();
      (0, _productSwatches["default"])().init(); // Refresh Yotpo widgets

      if (window.yotpo) {
        window.yotpo.refreshWidgets();
      }

      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Set loading state.
   */


  function setLoadingState() {
    nodeSelectors.viewport.classList.add(_cssClasses["default"].loading);
    nodeSelectors.body.innerHTML = _loaders["default"].ballPulse;
  }
  /**
   * Remove loading state.
   */


  function removeLoadingState() {
    nodeSelectors.viewport.classList.remove(_cssClasses["default"].loading);
  }
  /**
   * Initialise product form.
   */


  function initProductForm() {
    (0, _productForm["default"])({
      container: 'quickview',
      enableSwatches: true
    }).init();
  }
  /**
   * Set click events on buttons to post form data.
   */


  function setAddToCartEvents() {
    (0, _utils.on)('click', document.querySelector(selectors.addToCart), function (event) {
      return handleAddToCart(event);
    });
  }
  /**
   * Handle add to cart event and set loading state.
   * @param {object} event - Click and key down event.
   */


  function handleAddToCart(event) {
    event.preventDefault();
    var target = event.currentTarget;
    setAddingToCartState(target);

    _axios["default"].post('/cart/add.js', (0, _utils.serialize)(target.closest('form'))).then(function (response) {
      setSuccessState(target, response);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Set success state when item has been successfully added.
   * @param {HTMLElement} target - Add to cart button.
   * @param {Object} response - Successful JSON response from add.js.
   */


  function setSuccessState(target, response) {
    setDefaultState(target);
    modal.close();
    window.setTimeout(function () {
      Frame.EventBus.emit('AjaxCart:itemAdded', response);
    }, 500);
  }
  /**
   * Reset the loading states back to default.
   * @param {object} target clicked add to cart button in DOM.
   */


  function setDefaultState(target) {
    target.innerText = theme.strings.addToCart;
  }
  /**
   * Set adding state to add to cart button.
   * @param {object} target clicked add to cart button in DOM.
   */


  function setAddingToCartState(target) {
    target.innerText = theme.strings.addingToCart;
  }
  /**
   * Get quick view product template url.
   * @param {HTMLElement} element- Quick view button element.
   */


  function getProductUrl(element) {
    return "".concat(element.dataset.productUrl, "?view=quick-view");
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;